// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Account number:</span>
        <span class="value">{{\$ctrl.account.productNumber}}
        </span>
      </div>
    </div>

    <h2 class="section-header">Update account parameters</h2>

    <form name="\$ctrl.form">
      <validator condition="\$ctrl.hasValidOwnerConfiguration"></validator>
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
          <th></th>
          <th>Property</th>
          <th>Current state</th>
          <th>Target state</th>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>Tax exempted:</td>
            <td>{{\$ctrl.account.taxExempted | prettyBoolean}}</td>
            <td>
              <select
                      ng-model="\$ctrl.command.taxExempted"
                      boolean-options>
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Accrued interest:</td>
            <td>{{\$ctrl.account.accruedInterest | nxCurrency}}</td>
            <td>
              <cash ng-model="\$ctrl.command.accruedInterest"></cash>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Last accrual:</td>
            <td>{{\$ctrl.account.lastAccrualDate | nxDate}}</td>
            <td>
              <date output-format="date"
                ng-required="\$ctrl.command.accruedInterest > 0"
                ng-model="\$ctrl.command.lastAccrualDate"
                init-with-null="true"
                max="\$ctrl.branchSystemDate | nxDate"></date>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Last interest application:</td>
            <td>{{\$ctrl.account.lastInterestApplication | nxDate}}</td>
            <td>
              <date output-format="date"
                ng-model="\$ctrl.command.lastInterestApplication"
                init-with-null="true"
                max="\$ctrl.branchSystemDate | nxDate"></date>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Last dormancy charge:</td>
            <td>{{\$ctrl.account.lastDormancyCharge | nxDate}}</td>
            <td>
              <date output-format="date"
                ng-model="\$ctrl.command.lastDormancyCharge"
                init-with-null="true"
                max="\$ctrl.branchSystemDate | nxDate"></date>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Last maintaining charge:</td>
            <td>{{\$ctrl.account.lastMaintainingCharge | nxDate}}</td>
            <td>
              <date output-format="date"
                ng-model="\$ctrl.command.lastMaintainingCharge"
                init-with-null="true"
                max="\$ctrl.branchSystemDate | nxDate"></date>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Casa class code:</td>
            <td>{{\$ctrl.account.casaClassCode | prettyCasaClassCode}}</td>
            <td>
              <select
                      ng-model="\$ctrl.command.casaClassCode"
                      ng-options="o.value as o.label for o in \$ctrl.casaClassCodes">
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>PDIC type:</td>
            <td>{{\$ctrl.account.pdicTypeName}}</td>
            <td>
              <select
                      ng-model="\$ctrl.command.pdicTypeId"
                      ng-change="\$ctrl.pdicCasaTypesChanged()"
                      ng-options="o.id as o.name for o in \$ctrl.pdicCasaTypes">
              </select>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isCorporate">
            <td></td>
            <td>Signatories:</td>
            <td>{{\$ctrl.signatoryNames.join(' | ')}}</td>
            <td>
              <multiselect
                           items="\$ctrl.signatoryRelatives"
                           ng-model="\$ctrl.command.signatoryIds"
                           label-property="'effectiveName'"
                           value-property="'id'">
              </multiselect>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Extra number:</td>
            <td>{{\$ctrl.account.extraNumber}}</td>
            <td>
              <input
                      type="text"
                      maxlength="32"
                      ng-model="\$ctrl.command.extraNumber">
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Initial deposit performed:</td>
            <td>{{\$ctrl.account.initialDepositPerformed | prettyBoolean}}</td>
            <td>
              <select
                ng-model="\$ctrl.command.initialDepositPerformed"
                required
                boolean-options>
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Initial deposit date:</td>
            <td>{{\$ctrl.account.initialDepositDate | nxDate}}</td>
            <td>
              <date output-format="date"
                    min="\$ctrl.account.createdOn | nxDate"
                    ng-model="\$ctrl.command.initialDepositDate"
                    max="\$ctrl.branchSystemDate | nxDate"></date>
            </td>
          </tr>
          <tr class="table--skip-generate-row-id">
            <td colspan="4">
              <span class="alert">
                The values below override the values configured in the account product level. Account specific processes will depend on these.
              </span>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Interest crediting interval</td>
            <td>{{\$ctrl.account.creditingScheduler.interval}}</td>
            <td>
              <input
                required
                type="number"
                class="value"
                ng-model="\$ctrl.command.creditingScheduler.interval"
                min="1">
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Interest crediting cycle type</td>
            <td>{{\$ctrl.account.creditingScheduler.cycleType | prettyEnum}}</td>
            <td>
              <select
                required
                ng-model="\$ctrl.command.creditingScheduler.cycleType"
                ng-options="c.value as c.label for c in \$ctrl.cycleTypes">
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Interest rate:</td>
            <td>{{ \$ctrl.account.currentInterest }}</td>
            <td>
              <glue-container append-percentage="true">
                <input type="number"
                       ng-model="\$ctrl.command.interestRate"
                       min="0" max="10000" step="0.01">
              </glue-container>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Min. balance to earn interest:</td>
            <td>{{ \$ctrl.account.currentInterestMinimalBalance | nxCurrency}}</td>
            <td>
              <cash ng-model="\$ctrl.command.interestMinimalBalance"></cash>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Maintaining balance:</td>
            <td>{{ \$ctrl.account.currentMaintaningBalance | nxCurrency}}</td>
            <td>
              <cash ng-model="\$ctrl.command.maintainingBalance"></cash>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Max credit balance:</td>
            <td>{{ \$ctrl.account.currentMaxCreditBalance | nxCurrency}}</td>
            <td>
              <cash ng-model="\$ctrl.command.maxCreditBalance"></cash>
            </td>
          </tr>
        </tbody>
      </table>

      <custom-field-input
        group="'ACCOUNT'"
        available-custom-fields="\$ctrl.accountType.productDefinition.customFieldDefinitionIds"
        assigned-category-ids="\$ctrl.command.categoryIds"
        custom-field-values="\$ctrl.command.customFieldValues"
        branch-id="\$ctrl.account.branchId"
        customer-id="\$ctrl.account.customerId"
        edit-mode="true">
      </custom-field-input>

      <div ng-if="\$ctrl.multipleAccountOwnershipEnabled">
        <product-owners ownership="\$ctrl.command.ownership" edit-mode="true">
        </product-owners>
      </div>

      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-primary" ng-click="\$ctrl.update()" ng-disabled="\$ctrl.form.\$invalid">Update</button>
      </div>

    </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/edit-account/edit-account.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;